import {writable} from 'svelte/store';

let content = {api: {}, view: 'category', group: 0, item: 0};
const gallery = writable(content);

gallery.load = async () => {
	const url = './api/gallery.json';
	const response = await fetch(url);
	content.api = await response.json();
	gallery.set(content);
};

export default gallery;